const {
    NODE_ENV,
    REACT_APP_COLBI_THEME = "sovos",
    PUBLIC_URL,
    REACT_APP_PROXY_HOST = "",
    REACT_APP_SSO_BASE_URL = "https://account-dev.sovos.com/",
    REACT_APP_SSO_CLIENT_ID = "",
    REACT_APP_SSO_ID_ISSUER = "",
    REACT_APP_AUTH_MODE = "SSO",
    REACT_APP_SSO_REDIRECT_URI = `http://localhost:3000/v1/oidc/uri_callback`,
    REACT_APP_SAML_CLIENT_ID = "p__gvat-aprsaft-saml-dev",
    REACT_APP_SAML_REDIRECT_URI = `http://localhost:3000/v1/saml/uri_callback`,
    REACT_APP_SAML_BASE_URL = "https://dev.identity.sovos.com",
} = process.env;

const AUTH_CONFIG = {
    authority: `${REACT_APP_SSO_BASE_URL}`,
    issuer: `${REACT_APP_SSO_BASE_URL}`,
    authorization_endpoint: `${REACT_APP_SSO_BASE_URL}/api/oauth/authorize`,
    token_endpoint: `${REACT_APP_SSO_BASE_URL}/api/oauth/token`,
    jwks_uri: `${REACT_APP_SSO_BASE_URL}/.well-known/jwks`,
    client_id: REACT_APP_SSO_CLIENT_ID,
    redirect_uri: REACT_APP_SSO_REDIRECT_URI,
    post_logout_redirect_uri: REACT_APP_SSO_REDIRECT_URI,
};

export {
    NODE_ENV,
    REACT_APP_COLBI_THEME,
    PUBLIC_URL,
    REACT_APP_PROXY_HOST as apiDomain,
    REACT_APP_AUTH_MODE,
    REACT_APP_SSO_BASE_URL,
    AUTH_CONFIG,
    REACT_APP_SSO_ID_ISSUER,
    REACT_APP_SAML_CLIENT_ID,
    REACT_APP_SAML_REDIRECT_URI,
    REACT_APP_SAML_BASE_URL,
};
